import React from 'react';
import { ResourceListPage } from './list';

export const ResourcesModule = () => {
  return <ResourceListPage />;
};
